import React, { createContext, useState, useEffect, useContext } from "react";
import { fetchController } from "../../../utils/FetchController/fetchController";
import { toast } from "react-toastify";
import { theme, useColorModeValue } from "@chakra-ui/react";
import { getHostDomain } from "../../../utils/utils";
import AuthContext from "../../Auth/AuthContext";
import axios from "axios";
import { predefinedColors } from "../contants";

export const AgencyContext = createContext();
export const AgencyProvider = ({ children }) => {
  const baseUrl = getHostDomain();
  const [agencyData, setagencyData] = useState(null);
  const [myDetails, setMyDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [agencyName, setAgencyName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [themeColor, setThemeColor] = useState(null);
  const [colorPreset, setColorPreset] = useState(null);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [faviconUrl, setFaviconUrl] = useState(null);
  const [titleAgencyName, setTitleAgencyName] = useState(null);
  const cardBg = useColorModeValue("white", theme.colors.gray[700]);
  const { getUserData } = useContext(AuthContext);
  const checkIfResponseIsJson = (res) => {
    if (typeof res === "string") return null;
    return res;
  };

  const executeCustomScript = (scriptContent) => {
    if (!scriptContent) return;
    
    const scriptRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>|<script\b([^>]*)\/>/i;
    const match = scriptContent.match(scriptRegex);
    const scriptId = "custom-agency-script";
    document.getElementById(scriptId)?.remove();

    const scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.id = scriptId;

    if (match) {
      const attributes = match[1] || match[3] || "";
      const scriptText = match[2] || "";

      const srcMatch = attributes.match(/src=["']?([^"']+)["']?/i);
      if (srcMatch) {
        scriptElement.src = srcMatch[1];
      } 
      scriptElement.textContent = scriptText;

    } else {
      scriptElement.textContent = scriptContent
    }

    document.head.appendChild(scriptElement);
  };

  const getMyDetails = async () => {
    try {
      setLoading(true);
      const { data: response } = await axios.get(
        window.location.origin + "/api/v1/agency/get_my_details"
      );
      const resStringAgency = checkIfResponseIsJson(response);
      if (!resStringAgency) throw new Error("Insighto");
      setMyDetails(response);
      const favLogoUrl = response?.branding?.logo_url?.includes(window.origin)
        ? response?.branding?.logo_url
        : baseUrl + response?.branding?.logo_url;
      setFaviconUrl(favLogoUrl);
      setTitleAgencyName(response?.branding?.agency_name);
      localStorage.setItem("appDomain", response?.domain?.appDomain);
      localStorage.setItem("API_SERVER_URL", response?.domain?.apiDomain);
      localStorage.setItem("chatbotDomain", response?.domain?.chatbotDomain);

      setColorPreset(response.branding?.color_preset || "#3182ce");
      const data = predefinedColors.filter(
        (color) => color.color === response.branding?.color_preset
      );
      const colorName =
        data?.length > 0
          ? data[0].name.split("[")[0]?.toLocaleLowerCase()
          : "blue";
      localStorage.setItem("btnColorScheme", colorName);

      if (response?.branding?.agency_script) {
        executeCustomScript(response.branding.agency_script);
      }
    } catch (error) {
      console.log(error);

      setFaviconUrl("https://cdn.insighto.ai/bot.png");
      setTitleAgencyName("Insighto.ai");
      localStorage.setItem("btnColorScheme", "blue");
      localStorage.setItem("appDomain", "app.insighto.ai");
      const base =
        process.env.REACT_APP_SERVER_URL ===
        "https://ragify-be-staging.azurewebsites.net"
          ? "ragify-be-staging.azurewebsites.net"
          : "api.insighto.ai";
      localStorage.setItem("API_SERVER_URL", base);
      localStorage.setItem("chatbotDomain", "cdn.insighto.ai");
      setColorPreset("#3182ce");
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  const getAgencies = async () => {
    try {
      const response = await fetchController(
        baseUrl + `/api/v1/agency/list`,
        "GET"
      );
      setagencyData(response.data?.items[0]);
      setAgencyName(response.data?.items[0]?.branding?.agency_name);
      setColorPreset(
        response.data?.items[0]?.branding?.color_preset || "#3182ce"
      );
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreateAgency = async () => {
    if (!agencyName) return;
    setIsLoading(true);
    let orgRes = null;
    try {
      if (!agencyData) {
        orgRes = await fetchController(
          baseUrl + `/api/v1/user/create_org`,
          "POST",
          {
            name: agencyName,
            description: "",
            domain: "",
          }
        );
      }
      const userDetails = await getUserData();
      const agencyEndpoint = !agencyData
        ? "/api/v1/agency"
        : `/api/v1/agency/${agencyData.id}`;
      const apiMethod = agencyData ? "PUT" : "POST";
      const payloadForPostReq = {
        org_id: agencyData?.org_id || orgRes?.data?.id,
        branding: {
          color_preset: themeColor,
          agency_name: agencyName,
          agency_mail: userDetails.data.email,
        },
        billing_plan: {},
        user_auth: {},
        domain: {},
      };
      const payloadForPutReq = {
        org_id: agencyData?.org_id || orgRes?.data?.id,
        branding: {
          ...(agencyData?.branding ? agencyData.branding : {}),
          color_preset: themeColor,
          agency_name: agencyName,
          agency_mail: userDetails.data.email,
        },
      };
       await fetchController(
        agencyEndpoint,
        apiMethod,
        apiMethod === "POST" ? payloadForPostReq : payloadForPutReq
      );
      toast.success("Agency created successfully");
      getAgencies();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  const handleBrandCreate = async () => {
    if (!agencyData) {
      toast.info("Please create agency first");
      return;
    }
    try {
      setIsPending(true);
      await fetchController(
        baseUrl + `/api/v1/agency/${agencyData.id}`,
        "PUT",
        {
          branding: {
            ...agencyData.branding,
            color_preset: themeColor,
          },
        }
      );
      toast.success("Brand created successfully");
      const selectedColor = predefinedColors.filter(
        (color, i) => color.color === themeColor
      );
      const colorName =
        selectedColor?.length > 0
          ? selectedColor[0].name.split("[")[0]?.toLocaleLowerCase()
          : null;
      localStorage.setItem("btnColorScheme", colorName);
      getAgencies();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    getMyDetails();
  }, []);

  useEffect(() => {
    setAgencyName(agencyData?.branding?.agency_name);
  }, [agencyData]);
  useEffect(() => {
    setThemeColor(colorPreset || "#3182ce");
  }, [colorPreset]);
  const buttonColorScheme = useColorModeValue(
    myDetails ? localStorage.getItem("btnColorScheme") || "blue" : "blue",
    "gray"
  );
  const textColor = useColorModeValue(
    myDetails ? colorPreset || "#3182ce" : "#3182ce",
    "#3182ce"
  );
  return (
    <AgencyContext.Provider
      value={{
        agencyData,
        myDetails,
        getAgencies,
        loading,
        error,
        handleCreateAgency,
        setAgencyName,
        setThemeColor,
        themeColor,
        colorPreset,
        textColor,
        agencyName,
        isLoading,
        handleBrandCreate,
        isPending,
        setIsPending,
        buttonColorScheme,
        predefinedColors,
        cardBg,
        faviconUrl,
        titleAgencyName,
        getMyDetails,
      }}
    >
      {children}
    </AgencyContext.Provider>
  );
};
